// extracted by mini-css-extract-plugin
export default {"group":"RadioGroupStyles__group___8k9CO"};